import FaqsShow from "../components/faqs/Show";

export default [
  { name: 'Faqs', path: '/faqs', component: FaqsShow, meta: {  showHeaderBanner: false }},
  { name: 'Faq', path: '/faq', component: FaqsShow, meta: {  showHeaderBanner: false }}
]